import type { Locale } from 'date-fns';
// @ts-expect-error: implicitly has an 'any' type
import buildLocalizeFn from 'date-fns/locale/_lib/buildLocalizeFn';
import enUsLocale from 'date-fns/locale/en-US';

// From https://www.localeplanet.com/icu/ur/index.html
// and https://www.unicode.org/cldr/cldr-aux/charts/28/verify/dates/ur.html

const defaultEraValues = ['قبل مسیح', 'عیسوی'];
const eraValues = {
  narrow: defaultEraValues,
  abbreviated: defaultEraValues,
  wide: defaultEraValues,
};

const defaultMonthValues = [
  'جنوری',
  'فروری',
  'مارچ',
  'اپریل',
  'مئی',
  'جون',
  'جولائی',
  'اگست',
  'ستمبر',
  'اکتوبر',
  'نومبر',
  'دسمبر',
];
const narrowMonthValues = ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'];
const monthValues = {
  narrow: narrowMonthValues,
  abbreviated: defaultMonthValues,
  wide: defaultMonthValues,
};

const defaultDayValues = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
const dayValues = {
  narrow: defaultDayValues,
  short: defaultDayValues,
  abbreviated: defaultDayValues,
  wide: defaultDayValues,
};

const defaultDayPeriodValues = {
  am: 'AM',
  pm: 'PM',
  midnight: 'آدھی رات',
  morning: 'صبح',
  afternoon: 'دوپہر',
  evening: 'ማታ',
  night: 'رات',
};
const dayPeriodValues = {
  narrow: defaultDayPeriodValues,
  abbreviated: defaultDayPeriodValues,
  wide: defaultDayPeriodValues,
};

const defaultQuarterValues = ['پہلی سہ ماہی', 'دوسری سہ ماہی', 'تیسری سہ ماہی', 'چوتهی سہ ماہی'];
const narrowQuarterValues = ['1', '2', '3', '4'];
const quarterValues = {
  narrow: narrowQuarterValues,
  abbreviated: defaultQuarterValues,
  wide: defaultQuarterValues,
};

export const localize: Locale['localize'] = {
  ordinalNumber: enUsLocale.localize!.ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide',
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    formattingValues: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: (quarter: any) => Number(quarter) - 1,
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: dayPeriodValues,
    defaultFormattingWidth: 'wide',
  }),
};
